import {DataTableSortStatus} from 'mantine-datatable';
import {UsageEventRow} from '../types';

export const moduleConfig = {
    entityKey: 'usage-events',
    basePath: '/usage-events',
    noun: 'usage event',
    titles: {
        singular: 'Usage Event',
        plural: 'Usage Events'
    }
}

// The UsageEvent id is a COMPOSITE key (`usage-event:<meter>#<account>#<uuid>`) carrying
// `:` and `#`, so it MUST be encodeURIComponent'd before going into the path — a raw `#`
// truncates the path at the fragment, useParams().id comes back partial and
// getUsageEvent(<partial id>) resolves nothing. react-router v6 useParams() decodes it
// again, so the detail page receives the original id.
export const usageEventPath = (id: string) => `${moduleConfig.basePath}/${encodeURIComponent(id)}`;

// Newest-INGESTED first, on `receivedAt: AWSDateTime!` rather than `created: AWSDateTime`.
// `created` is nullable in the schema, and a nullable default key degrades to insertion
// order when rows lack it. `receivedAt` is stamped in the same ingest write as `created`
// (dev rows: `created` trails it by under 2s, in the same order), so this default agrees
// with the API's own `created DESC` order and the first paint does not reshuffle.
export const DEFAULT_SORT_STATUS: DataTableSortStatus<UsageEventRow> = {
    columnAccessor: 'receivedAt',
    direction: 'desc',
};

// Page size is a server concern, fixed by the module (§9).
export const PAGE_SIZE = 50;

// The filters are non-key FilterExpressions (FNP-594), so a filtered page can come back
// EMPTY with a nextToken: on dev, "Unresolved Customer = Yes" had 3 empty pages of 10
// before the first of 39 matches. While nothing has loaded, the list hook keeps paging,
// up to this many pages, so a filter that matches does not render as "no events". The cap
// keeps a filter that matches nothing from walking the whole partition unasked.
export const MAX_AUTO_DRAIN_PAGES = 10;
